import styled from '@emotion/styled';
import css from '@styled-system/css';
import { Text } from '../text';
export const baseStyles = css({
    display: 'inline-block',
    cursor: 'pointer',
    color: 'link',
    '&:visited': {
        color: 'visited',
    },
    '&:hover': {
        color: 'hover',
    },
});
export const TextLink = styled(Text) `
  ${baseStyles}
  color: ${(props) => props.color};
  ${({ noVisitedColorChange, color, theme }) => noVisitedColorChange &&
    `
      &:visited {
        color: ${color};
        &:hover {
          color: ${theme.colors.hover};
        }
      }
  `}

  text-decoration: ${(props) => props.showTextDecoration ? 'underline' : 'none'};

  ${({ underlineOnHover }) => underlineOnHover &&
    `
      &:hover {
        text-decoration: underline;
      }
    `}
`;
TextLink.defaultProps = {
    as: 'a',
    variant: 'inherit',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dExpbmsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90ZXh0LWxpbmsvVGV4dExpbmsudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLGlCQUFpQixDQUFDO0FBQ3JDLE9BQU8sR0FBMEIsTUFBTSxvQkFBb0IsQ0FBQztBQUM1RCxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBa0IvQixNQUFNLENBQUMsTUFBTSxVQUFVLEdBQUcsR0FBRyxDQUFDO0lBQzVCLE9BQU8sRUFBRSxjQUFjO0lBQ3ZCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLEtBQUssRUFBRSxNQUFNO0lBQ2IsV0FBVyxFQUFFO1FBQ1gsS0FBSyxFQUFFLFNBQVM7S0FDakI7SUFDRCxTQUFTLEVBQUU7UUFDVCxLQUFLLEVBQUUsT0FBTztLQUNmO0NBQ21CLENBQUMsQ0FBQztBQUV4QixNQUFNLENBQUMsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFlO0lBQy9DLFVBQVU7V0FDSCxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLEtBQUs7SUFDN0IsQ0FBQyxFQUFFLG9CQUFvQixFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQzNDLG9CQUFvQjtJQUNwQjs7aUJBRWEsS0FBSzs7bUJBRUgsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLOzs7R0FHbEM7O3FCQUVrQixDQUFDLEtBQUssRUFBRSxFQUFFLENBQzNCLEtBQUssQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxNQUFNOztJQUUvQyxDQUFDLEVBQUUsZ0JBQWdCLEVBQUUsRUFBRSxFQUFFLENBQ3pCLGdCQUFnQjtJQUNoQjs7OztLQUlDO0NBQ0osQ0FBQztBQUVGLFFBQVEsQ0FBQyxZQUFZLEdBQUc7SUFDdEIsRUFBRSxFQUFFLEdBQUc7SUFDUCxPQUFPLEVBQUUsU0FBUztDQUNuQixDQUFDIn0=